import React, { useEffect, useRef, useState } from 'react';
import { navbarTopMenu, PUBLIC_ROUTES } from '../../../helper/constants';
import { getFeaturedCategoryPath } from '../../../helper/utils';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { cartIcon, closeIcon, heartIcon, menuIcon, nextVIcon, profileIcon } from '../../../assets/icons';
import Logo from '../../../assets/images/common/comimport.png';
import { useDispatch, useSelector } from 'react-redux';
import { clearAuthLocalStorage, getAuthLocalStorage } from '../../../../storage/localStorage';
import WebButton from '../../../../component/library/webButton';
import Profile from '../../../../component/layout/profile';
import SearchBar from './searchBar';
import amazon from '../../../assets/images/integrations/amazon.png';
import shopify from '../../../assets/images/integrations/shopify.png';
import wooCommerce from '../../../assets/images/integrations/woo-commerce.png';
import wordpress from '../../../assets/images/integrations/wordpress.png';
import { useOutsideClick } from '../../../../base/context/OutsideClick';
import { AuthApiService } from '../../../../service/authApiService';
import { ToastTypes, useMessage } from '../../../../base/context/MessageProvider';
import { ProductsApiService } from '../../../../service/website/productsApiService';
import MenuBar from './menuBar';
import { fetchCartItems, fetchCartCount, selectCartItems, selectCartCount } from '../../../../redux/slices/cartSlice';
import { CartApiService } from '../../../service/cartApiService';
import './style.css';

export default function WebNavbar({ authPage = false }) {
  const [menu, setMenu] = useState(false);
  const [userProfile, setUserProfile] = useState(false);
  const [showIntegrations, setShowIntgrations] = useState(false);
  const [data, setData] = useState({});
  const [featuredCategories, setFeaturedCategories] = useState([]);

  const message = useMessage();
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenu = () => {
    setMenu(!menu);
  };

  const loadNavbarCategories = async () => {
    try {
      // ⚡ Use lightweight sections endpoint instead of full getHomeProducts (no product data needed for nav)
      const res = await ProductsApiService.getHomeProductSections();
      const all = res?.data || [];
      const navOnly = Array.isArray(all) ? all.filter((c) => c.isFeatured === true) : [];
      navOnly.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));
      setFeaturedCategories(navOnly);
    } catch (err) {
      // Do not block UX with a toast if the menu categories fail to load.
      // (Categories can still fail silently; navbar will render without them.)
      console.warn('Failed to load menu categories', err);
    }
  };

  useEffect(() => {
    loadNavbarCategories();
  }, []);


  const check = getAuthLocalStorage().isLoggedIn && getAuthLocalStorage().loginHeader;

  const handleUserProfile = () => {
    setUserProfile(true);
  };

  const handleLogin = () => {
    // navigate('/login');
    navigate('/login', { state: { from: location } });
  };

  const handleRegister = () => {
    // navigate('/signup');
    navigate('/signup', { state: { from: location } });
  };

  const handleIntegration = name => {
    if (name === 'Integrations') {
      setShowIntgrations(!showIntegrations);
    } else {
      setShowIntgrations(false);
    }
  };

  const handleSubscriptions = () => {
    if (check) {
      navigate('/seller/productSubscription');
    } else {
      // navigate('/login');
      navigate('/login', { state: { from: location } });
    }
  };

  // Check if path looks like a product URL (clean format: /{skuId}/{slug})
  const isProductUrl = (path) => {
    const segments = path.split('/').filter(Boolean);
    if (segments.length < 2) return false;
    const firstSegment = segments[0];
    return /^\d+$/.test(firstSegment) || /^[a-f0-9]{24}$/i.test(firstSegment);
  };

  // Public routes that should not redirect to login on auth errors
  const isPublicRoute = () => PUBLIC_ROUTES.some(route => location.pathname.startsWith(route)) || isProductUrl(location.pathname);

  //get user profile
  const handleUserProfileApi = () => {
    AuthApiService.getProfile()
      .then(res => {
        if (res.status.code === 200) {
          setData(res.data);
        } else if (res.status.code === 402) {
          // DON'T SHOW TOAST FOR LOGIN ERROR, DIRECTLY REDIRECT TO LOGIN PAGE
          message.showToast(res.error.message, ToastTypes.ERROR);
          clearAuthLocalStorage();
          // Don't redirect to login if on public routes (collection, product-details)
          if (!isPublicRoute()) {
            navigate('/login', { replace: true });
          }
        } else {
          message.showToast(res.error.message, ToastTypes.ERROR);
        }
      })
      .catch(err => {
        message.showToast(err?.message || 'Server error. Try again later', ToastTypes.ERROR);
      });
  };

  useEffect(() => {
    if (getAuthLocalStorage().isLoggedIn && getAuthLocalStorage().loginHeader) {
      handleUserProfileApi();
    }
  }, [getAuthLocalStorage().isLoggedIn]);

  //get cart
  const dispatch = useDispatch();

  const cart = useSelector(selectCartCount);

  useEffect(() => {
    dispatch(fetchCartCount());
  }, []);


  return (
    <div className="web_navbar_container">
      {/* Top Header Bar - Commented out: Be a Seller, Integrations, Pricing, Help Center */}
      {/* <div className="web_navbar_row_one">
        {navbarTopMenu.map((menu, index) => {
          return (
            <div key={index}>
              <Link
                to={menu.link}
                className={
                  location.pathname === menu.link
                    ? "web_navbar_menu_active web_navbar_menu"
                    : "web_navbar_menu"
                }
              >
                <p onClick={() => handleIntegration(menu.name)}>{menu.name}</p>
              </Link>
            </div>
          );
        })}

        {showIntegrations ? (
          <IntegrationPopup
            check={check}
            onClickOutside={() => {
              setShowIntgrations(false);
            }}
          />
        ) : null}
      </div> */}

      <div className="web_navbar_row_two">
        <div className="navbar_menu_logo_col">
          {!authPage && (
            <div className="navbar_menu_btn" onClick={handleMenu}>
              {menuIcon}
            </div>
          )}

          <Link className="navbar_logo_col" to="/">
            <img src={Logo} />
          </Link>
        </div>

        {!authPage && <SearchBar />}

        {!authPage && (
          <div className="navbar_auth_col">
            <div className="navbar_pricing_btn" onClick={() => navigate('/pricing')}>
              Pricing
            </div>
            {!check ? (
              <div className="web_navbar_auth_btn">
                <WebButton
                  className="web_navbar_btn web_login_btn"
                  text="Login"
                  onClick={() => handleLogin()}
                  type="button"
                />

                <WebButton
                  className="web_navbar_btn active_btn_without_shadow"
                  text="Register Now"
                  onClick={() => handleRegister()}
                  type="button"
                />
              </div>
            ) : (
              <div className="web_navbar_auth_icons">
                {/* Heart and cart: only for sellers (hidden when isSeller is false / affiliate-only) */}
                {(getAuthLocalStorage().userType === 'seller' || getAuthLocalStorage().userType === 'admin' || getAuthLocalStorage().userType === 'sub-admin') && getAuthLocalStorage().isSeller === true ? (
                  <>
                    <div className="navbar_icon" onClick={() => handleSubscriptions()}>
                      {heartIcon}
                    </div>
                    <div className="navbar_icon" onClick={() => navigate('/checkout/cart')}>
                      {cartIcon}
                      <div className="cart_count">{cart}</div>
                    </div>
                  </>
                ) : null}

                <div className="navbar_icon" onClick={() => handleUserProfile()}>
                  {profileIcon}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {!authPage && (
        <div className="web_navbar_row_three">
          <div className="navbar_menu_btn" onClick={handleMenu}>
            {menuIcon}
          </div>

          {/* All Products — hidden from nav (route /fc/all-products still works if linked elsewhere)
        <div>
          <Link
            to="/fc/all-products"
            className={
              location.pathname === "/fc/all-products"
                ? "web_navbar_menu_active web_navbar_menu"
                : "web_navbar_menu"
            }
          >
            All Products
          </Link>
        </div>
        */}

          {featuredCategories.map((cat) => {
            const fcPath = getFeaturedCategoryPath(cat.pageUrl);
            return (
              <Link
                key={cat.fcId || cat._id || cat.pageUrl}
                to={fcPath}
                className={
                  location.pathname === fcPath
                    ? 'web_navbar_menu_active web_navbar_menu featured-link'
                    : 'web_navbar_menu featured-link'
                }
              >
                {cat.name}
              </Link>
            );
          })}
        </div>
      )}



      {!authPage && (
        <div className="web_navbar_search_row">
          <SearchBar />
        </div>
      )}

      <MenuBar menu={menu} setMenu={setMenu} featuredCategories={featuredCategories} />

      <div className="web_navbar_popup_wrapper">
        {userProfile ? (
          <Profile
            data={data}
            onClickOutside={() => {
              setUserProfile(false);
            }}
          />
        ) : null}
      </div>
    </div>
  );
}

const IntegrationPopup = ({ check, onClickOutside }) => {
  const ref = useRef();

  const outsideClick = useOutsideClick();
  const location = useLocation();

  useEffect(() => {
    outsideClick.getComponent(ref, onClickOutside);
  }, [onClickOutside]);

  const platforms = [
    { name: 'Amazon', image: amazon },
    { name: 'Shopify', image: shopify },
    { name: 'Woocommerce', image: wooCommerce },
    { name: 'Wordpress', image: wordpress },
  ];

  const handlePage = () => {
    return check
      ? '/seller/marketplaceApis'
      : { pathname: '/login', state: { from: location } };
  };

  return (
    <div className="integration_popup" ref={ref}>
      {platforms.map((platform, index) => {
        return (
          <Link key={index} className="integration_popup_column" to={handlePage()}>
            <img src={platform.image} />
            <p>{platform.name}</p>
          </Link>
        );
      })}
    </div>
  );
};
